"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15.223 11.993a.402.402 0 0 1-.201.349l-4.403 2.515a.4.4 0 0 1-.599-.347V9.477a.4.4 0 0 1 .6-.348l4.402 2.516a.402.402 0 0 1 .201.348Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 6.743a2.083 2.083 0 0 0-2.083-2.083H4.083C2.933 4.66 2 5.593 2 6.743v10.5c0 1.15.933 2.084 2.083 2.084h15.834A2.083 2.083 0 0 0 22 17.243v-10.5Zm-2.917.25c.23 0 .417.187.417.417v9.167c0 .23-.186.416-.417.416H4.917a.417.417 0 0 1-.417-.416V7.41c0-.23.187-.417.417-.417h14.166Z"
})), "0 0 24 24", "Entertainment");